export enum SyncStatus {
  NotStarted = 'NotStarted',
  Inprogress = 'InProgress',
  Completed = 'Completed',
  InProgress = 'in_progress',
  Complete = 'complete',
  CompleteWithErrors = 'complete_with_errors',
  Failed = 'failed',
}
